"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  helpDocuments: {
    userRegistration: '用户注册',
    helpManual: '帮助手册'
  }
};